import React, { useEffect } from "react";
import FormItem from "@components/FormItem/FormItem";
import GenericDialog from "@components/GenericDialog/GenericDialog";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const REVIEW_TEXT_MAX_LENGTH = 1000;

interface ReviewDecisionDialogProps {
  open: boolean;
  testId: string;
  title: string;
  label: string;
  confirmLabel: string;
  required: boolean;
  isSubmitting: boolean;
  onConfirm: (text: string) => void;
  onClose: () => void;
}

type ReviewFormData = { text: string };

const ReviewDecisionDialog: React.FC<ReviewDecisionDialogProps> = ({
  open,
  testId,
  title,
  label,
  confirmLabel,
  required,
  isSubmitting,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();
  const form = useForm<ReviewFormData>({ defaultValues: { text: "" } });
  const { reset, watch, getValues } = form;

  useEffect(() => {
    if (!open) {
      reset({ text: "" });
    }
  }, [open, reset]);

  const blocked = required && (watch("text") ?? "").trim() === "";

  return (
    <GenericDialog
      open={open}
      testId={testId}
      title={title}
      cancelButtonText={t("common.cancel")}
      confirmButtonText={confirmLabel}
      confirmAction={() => onConfirm(getValues("text"))}
      handleCloseDialog={onClose}
      isSubmitting={isSubmitting}
      isConfirmDisabled={blocked}
      elementContent={
        <FormProvider {...form}>
          <FormItem<ReviewFormData, "text">
            name="text"
            type="textarea"
            label={label}
            required={required}
            minRows={3}
            maxRows={10}
            maxChars={REVIEW_TEXT_MAX_LENGTH}
            showCharCounter
            testId={`${testId}-text`}
          />
        </FormProvider>
      }
    />
  );
};

export default ReviewDecisionDialog;
